<vp-footer
	[bottomItems]="bottomMenu | menuItems"
	[editableInStoryblok]="_editable"
	[information]="hotelStore.hotelMainContact()"
	[menu]="{ items: footerMenu }"
	[socials]="socials"
	[title]="hotelStore.slug() || title"
	[usps]="usps | menuItems"
/>
